import React, { useEffect, useState } from "react";
import { gettingStartedSchema } from "../../../utils/validationSchemas";
import { useFormik } from "formik";
import Input from "../../common/FormInputs";
import Selector from "../../common/Selector";
import { getAllCategories, createCategory } from "../../../services/offerService";
import { useDispatch, useSelector } from "react-redux";
import { ReactComponent as DownArrow } from "../../../Assets/Icons/greyDownArrow.svg";
import GoogleMaps from "../../common/GoogleMaps";
import InputTextArea from "../../common/InputTextArea";
import PrimaryButton from "../../common/PrimaryButton";
import PhoneFormInput from "../../common/PhoneInput";
import {
  onboardExistingMerchant,
  sendInvite,
  getMerchantInviteByCode,
} from "../../../services/onboardingService";
import { emailVerification } from "../../../services/authService";
import msgIcon from "../../../Assets/Icons/envelopIcon.svg";
import Loader from "../../common/Loader";
import DetailsPopup from "../../common/DetailsPopup";
import { uploadFile } from "../../../utils/s3";
import { ReactComponent as CameraIcon } from "../../../Assets/Icons/cameraIcon.svg";
import toast from "../../../utils/toast";
import { useNavigate, useParams } from "react-router-dom";
import AlreadyRegisteredPopup from "../../common/AlreadyRegisteredPopup";
import s from "react-aws-s3";
import { use } from "react";
import { getMerchantProfiles } from "../../../services/merchantService";
import { getTokenData } from "../../../utils/connectStore";
import { useDispatch as useReduxDispatch, useSelector as useReduxSelector } from "react-redux";
import { setPendingCustomCategory, clearPendingCustomCategory } from "../../../redux/slices/onboardingSlice";

const GettingStarted = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const merchantEmail = useSelector((state) => state?.authReducer?.tokenData?.user?.email);
  const userId = useSelector((state) => state?.authReducer?.tokenData?.user?._id);

  console.log('merchantEmail', merchantEmail)
  const [categories, setCategories] = useState([]);
  const [locationDetails, setLocationDetails] = useState(null);
  const [showMap, setShowMap] = useState(false);
  const [categoryIds, setCategoryIds] = useState([]);
  const [emailSent, setEmailSent] = useState(false);
  const [logoFileImage, setLogoFileImage] = useState();
  const [logoFileData, setLogoFileData] = useState();
  const [logoPreviewStyle, setLogoPreviewStyle] = useState({});
  const [logoUrl, setLogoUrl] = useState();
  const loading = useSelector((state) => state?.onboardingReducer?.loading);
  const [logoLoading, setLogoLoading] = useState(false);
  const [showAlreadyRegisteredPopup, setShowAlreadyRegisteredPopup] =
    useState(false);
  const [showNewEmailPopup, setShowNewEmailPopup] = useState(false);
  const [showLoginPopup, setShowLoginPopup] = useState(false);
  const [emailExistsAsUser, setEmailExistsAsUser] = useState(false);
  const [isCheckingEmail, setIsCheckingEmail] = useState(false);
  const reduxDispatch = useReduxDispatch();
  const newCategoryTitle = useReduxSelector((state) => state?.onboardingReducer?.pendingCustomCategory || "");
  const [customCategoryId, setCustomCategoryId] = useState(null);
  const { referralCode } = useParams();
  const [isOnlineMerchant, setIsOnlineMerchant] = useState(false);
  const [isInvitedMerchant, setIsInvitedMerchant] = useState(false);

  const getCategoriesData = async () => {
    const categoryPromise = await dispatch(getAllCategories())?.unwrap();
    if (categoryPromise?.success === true) {
      setCategories(categoryPromise?.data);
    }
  };

  // Check if email is registered as User/Member
  const checkEmailExistsAsUser = async (emailValue) => {
    if (!emailValue || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailValue)) {
      setEmailExistsAsUser(false);
      return false;
    }

    // Skip validation if email is from authenticated merchant
    if (merchantEmail && emailValue === merchantEmail) {
      setEmailExistsAsUser(false);
      return false;
    }

    setIsCheckingEmail(true);
    try {
      const result = await dispatch(emailVerification({ email: emailValue }))?.unwrap();
      // If email exists (result?.data === true), it means it's registered as User/Member
      if (result?.success === true && result?.data === true) {
        setEmailExistsAsUser(true);
        setIsCheckingEmail(false);
        return true;
      } else {
        setEmailExistsAsUser(false);
        setIsCheckingEmail(false);
        return false;
      }
    } catch (error) {
      // If there's an error, assume email doesn't exist as User/Member
      setEmailExistsAsUser(false);
      setIsCheckingEmail(false);
      return false;
    }
  };

  // moved below Formik values to avoid referencing before initialization

  useEffect(() => {
    getCategoriesData();
  }, []);

  // Fetch invitation data if referralCode (invitation code) is present
  useEffect(() => {
    const fetchInviteData = async () => {
      if (referralCode) {
        try {
          const result = await dispatch(getMerchantInviteByCode(referralCode)).unwrap();
          if (result?.success && result?.data?.email) {
            setFieldValue("email", result.data.email);
            setIsInvitedMerchant(true);
          }
        } catch (error) {
          console.error("Failed to fetch invitation details:", error);
        }
      }
    };
    fetchInviteData();
  }, [referralCode]);

  const initialValues = {
    businessName: "",
    businessAddress: "",
    logo: "",
    websiteUrl: "",
    personName: "",
    personContact: "",
    email: merchantEmail || "",
    businessCategory: [],
    aboutBusiness: "",
    code: referralCode || "",
    password: "", // Added password field for login
    isOnlineMerchant: false,
  };
  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: gettingStartedSchema,

    onSubmit: async (values) => {
      // Check if email is registered as User/Member before submission (only for new signups, not existing merchant login)
      if (!values?.password && (!merchantEmail || values.email !== merchantEmail)) {
        const isUserEmail = await checkEmailExistsAsUser(values.email);
        if (isUserEmail) {
          formik.setFieldError("email", "This email is already registered. Please use a different email address or sign in with your existing account.");
          formik.setTouched({ ...formik.touched, email: true }, false);
          scrollToFirstError({ email: "This email is already registered." });
          return;
        }
      }

      const addressToSend = locationDetails
        ? locationDetails?.placeName
        : values?.businessAddress;
      console.log("create values", values);

      // Set Australia coordinates if online merchant
      const latitude = isOnlineMerchant ? -33.8688 : locationDetails?.latitude;
      const longitude = isOnlineMerchant ? 151.2093 : locationDetails?.longitude;

      const payload = {
        businessName: values?.businessName,
        address: isOnlineMerchant ? "Australia" : values?.businessAddress,
        logo: logoUrl,
        website: values?.websiteUrl,
        contactPersonName: values?.personName,
        contactPersonNumber: values?.personContact,
        email: values?.email,
        category: categoryIds,
        description: values?.aboutBusiness,
        referalCode: values?.code,
        isOnlineMerchant: isOnlineMerchant,
        latitude: latitude,
        longitude: longitude,
      };
      // const sendPromise = await dispatch(sendInvite(payload))?.unwrap();
      // console.log("se", sendPromise);
      // if (sendPromise?.success === true) {
      //   setEmailSent(true);
      // }
      console.log({ values });
      if (values?.password) {
        try {
          const passwordPromise = await dispatch(
            onboardExistingMerchant({ ...payload, password: values?.password })
          )?.unwrap();
          if (passwordPromise?.success === true) {
            const profilePromise = await dispatch(
              getMerchantProfiles({ id: userId })
            )?.unwrap();
            if (profilePromise?.success === true) {
              navigate("/merchant/dashboard");
              setFieldValue("password", "");
            }
          }
        } catch (error) {
          // Handle error for existing merchant login
          const errorMessage = error?.response?.data?.message || error?.message || "";
          if (errorMessage.toLowerCase().includes("invalid") || errorMessage.toLowerCase().includes("password")) {
            // Keep the login popup open and show error
            setShowLoginPopup(true);
            formik.setFieldError("password", errorMessage || "Invalid email or password");
            formik.setTouched({ ...formik.touched, password: true }, false);
          } else {
            toast.error(errorMessage || "Failed to onboard. Please try again.");
            // Keep the login popup open on other errors too
            setShowLoginPopup(true);
          }
        }
        return;
      }
      try {
        const sendPromise = await dispatch(sendInvite(payload))?.unwrap();
        if (sendPromise?.success === true) {
          if (sendPromise?.action == "new_profile_requires_password_verify") {
            setShowAlreadyRegisteredPopup(true);
            return;
          }
          setEmailSent(true);
          setEmailExistsAsUser(false);
          // toast.success("Invitation sent successfully!", {
          //   style: {
          //     background: "#E6F7FB",
          //     color: "#007EA7",
          //     borderRadius: "8px",
          //     boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)",
          //     padding: "12px 16px",
          //   },
          //   progressStyle: {
          //     background: "#007EA7",
          //   },
          //   icon: "✅",
          // }); // Show success toast
        } else {
          // toast.error(sendPromise?.message || "Failed to send invitation"); // Show error toast
        }
      } catch (error) {
        // Handle backend errors - check if email is already registered
        const errorMessage = error?.response?.data?.message || error?.message || "";
        if (errorMessage.toLowerCase().includes("already exists") ||
          errorMessage.toLowerCase().includes("already registered") ||
          errorMessage.toLowerCase().includes("user") ||
          errorMessage.toLowerCase().includes("member")) {
          formik.setFieldError("email", "This email is already registered. Please use a different email address or sign in with your existing account.");
          formik.setTouched({ ...formik.touched, email: true }, false);
          setEmailExistsAsUser(true);
          scrollToFirstError({ email: "This email is already registered." });
        } else {
          toast.error(errorMessage || "Failed to send invitation. Please try again.");
        }
      }
      setFieldValue("password", "");
    },
  });

  const {
    businessName,
    businessAddress,
    logo,
    websiteUrl,
    personName,
    personContact,
    email,
    businessCategory,
    aboutBusiness,
    code,
    password, // Added password field for login
  } = formik.values;

  const {
    handleChange,
    handleBlur,
    errors,
    touched,
    setFieldValue,
    handleSubmit,
    setValues,
  } = formik;

  const scrollToFirstError = (formErrors) => {
    console.log("Scroll to first error called with:", formErrors);
    const priority = [
      'businessName',
      'businessAddress',
      'logo',
      'websiteUrl',
      'businessCategory',
      'personName',
      'email',
      'personContact',
      'aboutBusiness'
    ];
    let targetField = priority.find((key) => formErrors && Object.prototype.hasOwnProperty.call(formErrors, key));
    if (!targetField) {
      const keys = Object.keys(formErrors || {});
      targetField = keys.length ? keys[0] : null;
    }
    console.log("Target field:", targetField);
    if (!targetField) return;

    // Try multiple selectors to find the element
    let el = document.querySelector(`[data-field="${targetField}"]`);
    if (!el) el = document.querySelector(`[name="${targetField}"]`);
    if (!el) el = document.querySelector(`input[name="${targetField}"]`);
    if (!el) el = document.querySelector(`textarea[name="${targetField}"]`);
    if (!el) el = document.querySelector(`select[name="${targetField}"]`);

    console.log("Found element:", el);
    if (el && typeof el.scrollIntoView === 'function') {
      el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      if (typeof el.focus === 'function') {
        try { el.focus(); } catch (_) { }
      }
    } else {
      console.log("Element not found or scrollIntoView not available");
    }
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = await formik.validateForm();
    if (Object.keys(validationErrors || {}).length > 0) {
      formik.setTouched(Object.keys(validationErrors).reduce((acc, k) => { acc[k] = true; return acc; }, {}), true);
      scrollToFirstError(validationErrors);
      return;
    }
    // Before submit, fold in the custom category only now
    try {
      if (Array.isArray(businessCategory) && businessCategory.includes("Other") && newCategoryTitle && newCategoryTitle.trim() !== "") {
        const updated = [
          ...businessCategory.filter((c) => c !== "Other" && c?.trim?.() !== ""),
          newCategoryTitle.trim(),
        ];
        setFieldValue("businessCategory", updated);
      }
    } catch (_) { }
    handleSubmit(e);
  };

  console.log("errors", errors);

  // Safe options mapping now that formik values exist
  const businessCategoryOptions = categories
    ?.filter((cat) => {
      // Show only global categories (no merchant association)
      const isGlobal = !(cat?.merchantId || cat?.merchant || cat?.createdBy);
      const notAlreadySelected = !(Array.isArray(businessCategory) ? businessCategory : []).includes(cat?.title);
      return isGlobal && notAlreadySelected;
    })
    ?.slice(0, 6) // Only show first 6 global categories
    ?.map((cat) => ({
      value: cat?.title ?? "abc",
      label: cat?.title ?? "dsc",
    }));

  // Debug logging
  console.log('All categories received:', categories?.length, 'categories');
  console.log('Global categories found:', categories?.filter(cat => !(cat?.merchantId || cat?.merchant || cat?.createdBy))?.length);
  console.log('Filtered business category options (6 main):', businessCategoryOptions?.length, 'options');

  const handleClosePopup = () => {
    setEmailSent(false); // Close popup by setting emailSent to false
  };

  const validateImage = (data) => {
    var idxDot = data.lastIndexOf(".") + 1;
    var extFile = data.substr(idxDot, data.length).toLowerCase();
    if (
      extFile == "jpg" ||
      extFile == "jpeg" ||
      extFile == "png" ||
      extFile == "svg"
    ) {
      return true;
    } else {
      return false;
    }
  };

  const handleUploadLogo = async (event) => {
    const file = event.target.files?.[0];
    if (!file) return;

    let fileName = file.name;
    setFieldValue("logo", fileName);
    setLogoLoading(true);
    const s3Url = await uploadFile(file, fileName);
    console.log("s3Url", s3Url);
    if (s3Url) {
      setLogoUrl(s3Url);
      setLogoLoading(false);
    }
    let checkValidImage = validateImage(fileName);

    if (checkValidImage) {
      let logoImageUrl = URL.createObjectURL(file);
      setLogoFileImage(logoImageUrl);
      localStorage.setItem("profilePic", logoImageUrl);
      setLogoFileData(file);
      setLogoPreviewStyle({});
    } else {
      toast.error("Only jpg/jpeg, png, and svg files are allowed!", "warning");
    }

    // Clear the input value after processing to allow selecting the same file again
    // Use setTimeout to ensure the onChange has fully processed
    setTimeout(() => {
      event.target.value = null;
    }, 0);
  };

  const handleClearLogo = () => {
    setFieldValue("logo", "");
    setLogoFileImage(undefined);
    setLogoFileData(undefined);
    setLogoPreviewStyle({});
  };

  const handleLocationClick = () => {
    setShowMap(true);
  };

  const handleLocationSelect = (selectedLocation) => {
    setFieldValue("businessAddress", selectedLocation?.placeName);
    setLocationDetails(selectedLocation);
  };

  const handleCategoryChange = (newCategory) => {
    const currentCategories = Array.isArray(businessCategory)
      ? businessCategory
      : [];

    let updatedCategories;

    if (currentCategories.includes(newCategory)) {
      updatedCategories = currentCategories.filter(
        (category) => category !== newCategory
      );
    } else {
      updatedCategories = [...currentCategories, newCategory];
    }

    setFieldValue("businessCategory", updatedCategories);
  };

  const handleCategoryDeselect = (removedCategory) => {
    const updatedCats = businessCategory.filter(
      (category) => category !== removedCategory
    );
    setFieldValue("businessCategory", updatedCats);
  };

  useEffect(() => {
    if (businessCategory?.length !== 0 && categories?.length !== 0) {
      const catIds = businessCategory?.map((businessCategoryName) => {
        const matchingCategories = categories?.filter(
          (cat) => cat?.title === businessCategoryName
        );
        return matchingCategories?.map((cat) => cat?._id);
      });
      setCategoryIds(catIds?.flat());
    }
  }, [businessCategory, categories]);

  useEffect(() => {
    if (referralCode) {
      setFieldValue("code", referralCode);
    }
  }, [referralCode]);

  const onUseDifferent = () => {
    setShowNewEmailPopup(true);
    setShowAlreadyRegisteredPopup(false);
    // Clear any password errors when switching popups
    formik.setFieldError("password", "");
    formik.setTouched({ ...formik.touched, password: false }, false);
  };
  const oncreateSame = () => {
    setShowLoginPopup(true);
    setShowAlreadyRegisteredPopup(false);
    // Clear any previous password errors when opening login popup
    formik.setFieldError("password", "");
    formik.setTouched({ ...formik.touched, password: false }, false);
    setFieldValue("password", "");
  };
  const onCreateDairyBlend = () => { };
  const onLogin = () => { };
  const BusinessName = (name) => {
    if (typeof name === "string" && name.length > 10) {
      return name.slice(0, 10) + "...";
    }
    return name;
  };

  return (
    <form
      className="w-full min-h-screen py-6 sm:py-8 md:py-10 px-4 sm:px-6 md:px-0 flex flex-col items-center offerform"
      onSubmit={handleFormSubmit}
    >
      {loading && <Loader />}
      {emailSent === true && (
        <AlreadyRegisteredPopup
          popupClassName={"w-[335px] sm:w-[470px] pb-5"}
          content={
            <div className="flex flex-col items-center p-6">
              <img src={msgIcon} className="w-[50px] h-[50px] mb-4" alt="Email Sent" />
              <h3 className="text-[18px] font-[600] text-[#303030] mb-2 font-poppins">Invitation Sent!</h3>
              <p className="text-[14px] text-[#767676] text-center mb-6 font-poppins">
                We have sent an invitation to your email to join Swoodle. Please check your inbox (and spam folder) to continue.
              </p>
              <PrimaryButton
                label="OK"
                className="w-[120px] h-[45px] rounded-[5px] font-poppins font-[500] bg-[#00ADEF] text-white"
                onClick={() => {
                  setEmailSent(false);
                  formik.resetForm();
                  navigate("/");
                  window.scrollTo(0, 0);
                }}
              />
            </div>
          }
        />
      )}
      {showAlreadyRegisteredPopup === true && (
        <AlreadyRegisteredPopup
          popupClassName={"w-[335px] sm:w-[470px] pb-5"}
          content={
            <>
              <div className="p-6 text-center">
                <h2 className="text-lg font-semibold text-gray-900 mb-4">
                  Email Already Registered
                </h2>

                <p className="text-sm text-gray-600 mb-6 leading-relaxed">
                  This email address is currently registered to Dairy Bell.
                  Would you like to create a second business, with the same
                  email?
                </p>

                <div className="flex gap-3">
                  <PrimaryButton
                    onClick={oncreateSame}
                    className="w-full font-poppins sm:text-[12px] md:text-[13px] lg:text-[14px] text-center font-[600] font-[500] rounded-[10px] py-2.5 bg-white border border-[#00ADEF] text-[#00ADEF] hover:bg-[#00ADEF] hover:text-white transition-colors"
                    label={`Yes, create ${BusinessName(businessName)}`}
                  />

                  <PrimaryButton
                    onClick={onUseDifferent}
                    className="w-full font-poppins sm:text-[12px] md:text-[13px] lg:text-[14px] text-center font-[600] font-[500] rounded-[10px] py-2.5 bg-white border border-[#00ADEF] text-[#00ADEF] hover:bg-[#00ADEF] hover:text-white transition-colors"
                    label={"No, use a different email"}
                  />
                </div>
              </div>
            </>
          }
          handleClose={() => setShowAlreadyRegisteredPopup(false)} // Pass handleClosePopup to DetailsPopup
        />
      )}
      {showNewEmailPopup === true && (
        <AlreadyRegisteredPopup
          popupClassName={"w-[335px] sm:w-[470px] pb-5"}
          content={
            <>
              <div className="p-6 text-center w-full">
                <h2 className="text-lg font-semibold text-gray-900 mb-4">
                  Use a Different Email Address
                </h2>

                <Input
                  type="text"
                  label=""
                  placeholder="Email Address"
                  width="100%"
                  radius="5px"
                  InputDivClass="w-full mt-4"
                  name="email"
                  value={email}
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                  error={errors.email}
                  touched={touched.email}
                  disabled={merchantEmail ? true : false}
                />

                <div className="flex gap-3 mt-3">
                  <PrimaryButton
                    onClick={() => {
                      setShowNewEmailPopup(false);
                      setShowAlreadyRegisteredPopup(true);
                    }}
                    className="w-full font-poppins sm:text-[12px] md:text-[13px] lg:text-[14px] text-center font-[600] font-[500] rounded-[10px] py-2.5 bg-white border border-[#00ADEF] text-[#00ADEF] hover:bg-[#00ADEF] hover:text-white transition-colors"
                    label={"BACK"}
                  />

                  <PrimaryButton
                    onClick={() => {
                      setShowNewEmailPopup(false);
                      handleSubmit();
                    }}
                    className="w-full font-poppins sm:text-[12px] md:text-[13px] lg:text-[14px] text-center font-[600] font-[500] rounded-[10px] py-2.5 bg-white border border-[#00ADEF] text-[#00ADEF] hover:bg-[#00ADEF] hover:text-white transition-colors"
                    label={`Create ${BusinessName(businessName)}`}
                  />
                </div>
              </div>
            </>
          }
          handleClose={() => setShowNewEmailPopup(false)} // Pass handleClosePopup to DetailsPopup
        />
      )}
      {showLoginPopup === true && (
        <AlreadyRegisteredPopup
          popupClassName={"w-[335px] sm:w-[470px] pb-5"}
          content={
            <>
              <div className="p-6 text-center w-full">
                <h2 className="text-lg font-semibold text-gray-900 mb-4">
                  Use Existing email and password
                </h2>

                <Input
                  type="text"
                  label=""
                  placeholder="Email Address"
                  width="100%"
                  radius="5px"
                  InputDivClass="w-full mt-4"
                  name="email"
                  value={email}
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                  error={errors.email}
                  touched={touched.email}
                  disabled={merchantEmail ? true : false}
                />
                <Input
                  type="password"
                  label=""
                  placeholder="Password"
                  width="100%"
                  radius="5px"
                  InputDivClass="w-full mt-4"
                  name="password"
                  value={password}
                  handleChange={(e) => {
                    handleChange(e);
                    // Clear error when user types
                    if (errors.password) {
                      formik.setFieldError("password", "");
                    }
                  }}
                  handleBlur={handleBlur}
                  error={errors.password}
                  touched={touched.password}
                />

                <div className="flex gap-3 my-3">
                  <PrimaryButton
                    onClick={() => {
                      setShowLoginPopup(false);
                      setShowAlreadyRegisteredPopup(true);
                      // Clear password field and errors when going back
                      setFieldValue("password", "");
                      formik.setFieldError("password", "");
                      formik.setTouched({ ...formik.touched, password: false }, false);
                    }}
                    className="w-full font-poppins sm:text-[12px] md:text-[13px] lg:text-[14px] text-center font-[600] font-[500] rounded-[10px] py-2.5 bg-white border border-[#00ADEF] text-[#00ADEF] hover:bg-[#00ADEF] hover:text-white transition-colors"
                    label={"BACK"}
                  />

                  <PrimaryButton
                    onClick={async () => {
                      // Submit the form - handleSubmit will handle errors and keep popup open if needed
                      await handleSubmit();
                      // Check errors after a brief delay to allow formik state to update
                      setTimeout(() => {
                        if (!formik.errors.password) {
                          setShowLoginPopup(false);
                        }
                      }, 100);
                    }}
                    className="w-full font-poppins sm:text-[12px] md:text-[13px] lg:text-[14px] text-center font-[600] font-[500] rounded-[10px] py-2.5 bg-white border border-[#00ADEF] text-[#00ADEF] hover:bg-[#00ADEF] hover:text-white transition-colors"
                    label={`Login to ${BusinessName(businessName)}`}
                  />
                </div>
              </div>
            </>
          }
          handleClose={() => {
            setShowLoginPopup(false);
            // Clear password field and errors when popup is closed
            setFieldValue("password", "");
            formik.setFieldError("password", "");
            formik.setTouched({ ...formik.touched, password: false }, false);
          }} // Pass handleClosePopup to DetailsPopup
        />
      )}
      <div className="w-full flex flex-col items-start sm:items-center px-2 sm:px-0">
        <p className="font-poppins font-[600] text-[20px] leading-[28px] sm:text-[18px] sm:font-[500] md:text-[24px] lg:text-[32px] text-[#303030] text-left sm:text-center">
          Get Started with <span className="text-[#00ADEF]">Swoodle</span>
        </p>
        <p className="font-poppins font-[400] text-[10px] sm:text-[12px] md:text-[14px] lg:text-[16px] text-[#767676] leading-[18px] sm:leading-[20px] md:leading-[24px] lg:leading-[27px] mt-2 mb-5 text-left sm:text-center">
          Enter your details below and start your journey
        </p>
      </div>
      <div className="flex flex-col items-center w-full max-w-[640px] sm:w-[70%] md:w-[60%] lg:w-[50%] xl:w-[45%] 2xl:w-[40%] getStarted px-2 sm:px-0">
        <Input
          type="text"
          label=""
          placeholder="Enter Business Name"
          width="100%"
          radius="5px"
          inputClass="placeholder:!text-[#767676]"
          InputDivClass="w-full mt-4"
          name="businessName"
          data-field="businessName"
          value={businessName}
          handleChange={handleChange}
          handleBlur={handleBlur}
          error={errors.businessName}
          touched={touched.businessName}
        />
        <Selector
          value={businessCategory}
          label={""}
          labelClassName="lg:text-[14px] sm:text-[12px] font-[400] text-[#303030] mb-2 font-poppins lg:leading-[27px] sm:leading-[21px]"
          divClassName="mt-4 w-full multipleField"
          selectClassName="w-full rounded-[5px] bg-[#FFFFFF] text-[#303030] lg:text-[16px] sm:text-[12px] font-[400] outline-none !font-poppins !focus:outline-none"
          flexClassName="gap-1"
          options={[
            ...(businessCategoryOptions || []),
            { label: "Other", value: "Other" },
          ]}
          suffixIcon={<DownArrow />}
          placeholder={<span className="text-[#767676] -ml-3 text-[14px] sm:text-[14px]">Select Business Category</span>}
          onChange={(values) => setFieldValue("businessCategory", values)}
          handleBlur={handleBlur}
          error={errors.businessCategory}
          touched={touched.businessCategory}
          multiple={true}
          onDeselect={handleCategoryDeselect}
          data-field="businessCategory"
          inputReadOnly={true}
          showSearch={false}
        />
        {/* {Array.isArray(businessCategory) && businessCategory.includes("Other") && (
          <div className="relative w-full mt-4">
            <InputTextArea
              label={""}
              placeholder={"Write other business category..."}
              divClassName="w-full"
              labelClassName="invitationLabels"
              textareaClassName="w-full h-[100px] px-4 pt-3 rounded-[10px] bg-[#F2F2F2] text-[#303030] lg:text-[14px] sm:text-[12px] font-[400] outline-none resize-none font-poppins pr-24 pb-12 placeholder:text-[10px] sm:placeholder:text-[12px] lg:placeholder:text-[14px]"
              name="newBusinessCategory"
              data-field="newBusinessCategory"
              value={newCategoryTitle}
              handleBlur={handleBlur}
              error={errors.newBusinessCategory}
              touched={touched.newBusinessCategory}
              setFieldValue={(name, val) => reduxDispatch(setPendingCustomCategory(val))}
              showCounter={false}
            />
            <div className="absolute bottom-4 right-4">
              <PrimaryButton
                type="button"
                className="font-poppins text-[13px] sm:text-[12px] md:text-[13px] lg:text-[14px] text-center font-[500] h-[32px] sm:h-[32px] md:h-[36px] lg:h-[38px] rounded-[7px] px-3"
                label="Submit"
                disabled={!newCategoryTitle || newCategoryTitle.trim() === ""}
                onClick={async () => {
                  if (!newCategoryTitle || newCategoryTitle.trim() === "") return;

                  // Store the custom category locally (like Fundraiser onboarding)
                  const customCategory = {
                    _id: `temp_${Date.now()}`, // Temporary ID
                    title: newCategoryTitle.trim(),
                    isCustom: true
                  };

                  setCustomCategoryId(customCategory._id);
                  setCategories((prev) => [customCategory, ...(prev || [])]);

                  const updated = [
                    ...businessCategory.filter((c) => c !== "Other" && c?.trim?.() !== ""),
                    customCategory.title,
                  ];
                  setFieldValue("businessCategory", updated);
                  reduxDispatch(setPendingCustomCategory(newCategoryTitle.trim()));
                  toast.success("Custom category added successfully.");
                }}
              />
            </div>
          </div>
        )} */}


        {Array.isArray(businessCategory) && businessCategory.includes("Other") && (
          <div className="relative w-full mt-4">
            <InputTextArea
              label={""}
              placeholder={"Write other business category..."}
              divClassName="w-full"
              labelClassName="invitationLabels"
              textareaClassName="w-full h-[100px] px-4 pt-3 rounded-[10px] bg-[#F2F2F2] text-[#303030] lg:text-[14px] sm:text-[12px] font-[400] outline-none resize-none font-poppins pr-24 pb-12 placeholder:text-[12px] sm:placeholder:text-[13px] lg:placeholder:text-[15px]"
              name="newBusinessCategory"
              data-field="newBusinessCategory"
              value={newCategoryTitle}
              handleBlur={handleBlur}
              error={errors.newBusinessCategory}
              touched={touched.newBusinessCategory}
              setFieldValue={(name, val) => reduxDispatch(setPendingCustomCategory(val))}
              showCounter={false}
            />

            <div className="absolute bottom-4 right-4">
              <PrimaryButton
                type="button"
                className="font-poppins text-[13px] sm:text-[12px] md:text-[13px] lg:text-[14px] text-center font-[500] h-[32px] sm:h-[32px] md:h-[36px] lg:h-[38px] rounded-[7px] px-3"
                label="Submit"
                disabled={!newCategoryTitle || newCategoryTitle.trim() === ""}
                onClick={async () => {
                  if (!newCategoryTitle || newCategoryTitle.trim() === "") return;

                  try {
                    // 1. Call backend API to create category
                    const result = await dispatch(
                      createCategory({
                        title: newCategoryTitle.trim(),
                        image: null, // optional
                      })
                    ).unwrap();

                    if (result?.success) {
                      const newCreatedCategory = result?.data;

                      // 2. Add new category to local categories list
                      setCategories((prev) => [newCreatedCategory, ...(prev || [])]);

                      // 3. Replace "Other" in selected categories with new category
                      const updatedCategories = [
                        ...businessCategory.filter(
                          (c) => c !== "Other" && c?.trim() !== ""
                        ),
                        newCreatedCategory.title
                      ];

                      setFieldValue("businessCategory", updatedCategories);

                      // 4. Update categoryIds (used for invite API)
                      const updatedIds = updatedCategories.map((catName) => {
                        const match = categories.find((c) => c.title === catName);
                        return match?._id || (catName === newCreatedCategory.title ? newCreatedCategory._id : null);
                      }).filter(Boolean);

                      setCategoryIds(updatedIds);

                      // 5. Clear temporary state and show success toast
                      reduxDispatch(setPendingCustomCategory(""));
                      toast.success("Category created successfully.");
                    }
                  } catch (error) {
                    console.error("Failed to create category:", error);
                    toast.error(error?.message || "Failed to create category");
                  }
                }}
              />
            </div>
          </div>
        )}


























        {/* {!isOnlineMerchant && (
          <p className="mt-3 sm:mt-4 w-full text-[#767676] text-center px-1 text-[10px] sm:text-[12px] md:text-[14px] lg:text-[16px] leading-[16px] sm:leading-[18px] md:leading-[20px] lg:leading-[22px]">
            Enter your business address into the search bar, below. When the
            correct address appears, press Enter to confirm.
          </p>
        )} */}

        {!isOnlineMerchant && (
          <div className="w-full mt-4" data-field="businessAddress">
            <style>{`
              .merchant-map-container .gm-fullscreen-control {
                top: 53px !important;
              }
              /* Force show desktop search bar on mobile (override Tailwind 'hidden' class) */
              .merchant-map-container .hidden.sm\\:block {
                display: block !important;
              }
              /* Hide default mobile search button and expanded view */
              .merchant-map-container .sm\\:hidden {
                display: none !important;
              }
            `}</style>
            <div className="merchant-map-container">
              <GoogleMaps
                onLocationSelect={handleLocationSelect}
                searchContainerClass="!w-[98%] !left-[1%] md:!w-[96%]"
                placeholder="Add business address"
                searchBarDivClassName="w-full flex items-center h-[50px] relative"
                searchBarInputClassName="navSearchBar h-full w-[100%] ps-[3%] pe-[12%] text-[14px] font-[400] font-poppins outline-none bg-white text-[#303030] rounded-[5px] border border-[#D9D9D9] placeholder:!text-[#767676]"
                searchIconClassName="absolute right-[3%] w-[20px] h-[20px]"
              />
            </div>
            {errors.businessAddress && touched.businessAddress ? (
              <div className="ms-1 mt-1 w-full flex justify-start items-start">
                <span className="text-red-600 sm:text-[10px] md:text-[12px] font-[600] text-start">
                  {errors.businessAddress}
                </span>
              </div>
            ) : null}
          </div>
        )}
        {/* {!isOnlineMerchant && (
          <Input
            type="text"
            label=""
            placeholder="Business address will be displayed here"
            width="100%"
            radius="5px"
            InputDivClass="w-full mt-4"
            inputClass="disabled:!bg-gray-100 disabled:cursor-not-allowed placeholder:!text-[#767676]"
            name="businessAddress"
            data-field="businessAddress"
            value={businessAddress}
            handleChange={handleChange}
            handleBlur={handleBlur}
            error={errors.businessAddress}
            touched={touched.businessAddress}
            onClick={handleLocationClick}
            disabled={businessAddress?.length == 0}
          />
        )} */}

        {/* Checkbox for online merchant - outer container box */}
        <div className="w-full mt-4 p-4 bg-white border border-[#D9D9D9] rounded-[5px]">
          <div className="flex items-center gap-2">
            {/* HIDDEN DEFAULT CHECKBOX */}
            <input
              type="checkbox"
              id="isOnlineMerchant"
              checked={isOnlineMerchant}
              onChange={(e) => {
                const checked = e.target.checked;
                setIsOnlineMerchant(checked);
                setFieldValue("isOnlineMerchant", checked);
                if (checked) {
                  setFieldValue("businessAddress", "Australia");
                  setLocationDetails({
                    placeName: "Australia",
                    latitude: -33.8688,
                    longitude: 151.2093
                  });
                } else {
                  setFieldValue("businessAddress", "");
                  setLocationDetails(null);
                }
              }}
              className="peer hidden"
            />

            {/* CUSTOM CHECKBOX */}
            <label
              htmlFor="isOnlineMerchant"
              className={`w-5 h-5 border rounded-[3px] flex items-center justify-center cursor-pointer transition ${isOnlineMerchant
                ? 'bg-[#00ADEF] border-[#00ADEF]'
                : 'border-[#00ADEF] bg-white'
                }`}
            >
              {/* White Tick */}
              {isOnlineMerchant && (
                <svg
                  className="w-4 h-4 transition"
                  fill="none"
                  stroke="white"
                  strokeWidth="3"
                  viewBox="0 0 24 24"
                >
                  <path d="M5 13l4 4L19 7" />
                </svg>
              )}
            </label>

            <label
              className="font-poppins text-[12px] sm:text-[13px] md:text-[14px] text-[#303030] cursor-pointer select-none"
            >
              I deal in online offers and don't have a physical address.
            </label>
          </div>

          {/* Show Australia region box when online merchant is checked - nested inside */}
          {isOnlineMerchant && (
            <div className="mt-3 p-3 bg-[#F9F9F9] border border-[#E5E5E5] rounded-[5px] cursor-not-allowed">
              <p className="font-poppins text-[13px] sm:text-[14px] md:text-[15px] text-[#767676] font-[400]">
                Region: Australia
              </p>
            </div>
          )}
        </div>
        <PhoneFormInput
          label={""}
          divClassName="w-full mt-4"
          name="personContact"
          data-field="personContact"
          value={personContact}
          handleBlur={handleBlur}
          error={errors.personContact}
          touched={touched.personContact}
          setFieldValue={setFieldValue}
          placeholder={"Enter Business Number"}
          inputStyle={{
            width: "100%",
            border: "none",
          }}
          buttonStyle={{ border: "none" }}
          buttonClass="!rounded-l-[5px] !bg-[#D9D9D9] md:!w-[13%] sm:!w-[15%] lg:!w-[9%] xl:!w-[7%] 2xl:!w-[6%]"
          containerClass="!rounded-[5px]"
          inputClass="lg:!h-[45px] md:!h-[45px] !rounded-[5px] !bg-[#FFFFFF] !text-[#303030] lg:!text-[16px] sm:text-[14px] !font-[400] !outline-none !font-poppins placeholder:!text-[#767676] placeholder:!opacity-100 placeholder:!font-poppins placeholder:!text-[14px]"
          labelClass="mb-5"
          errorClass={
            "text-red-600 text-[10px] sm:text-[10px] md:text-[12px] font-[600] ms-1"
          }
        />

        {errors.logo && touched.logo ? (
          <div className="ms-1 mt-1 w-full flex justify-start items-start">
            <span className="text-red-600 sm:text-[10px] md:text-[12px] font-[600] text-start">
              {errors.logo}
            </span>
          </div>
        ) : null}
        <Input
          type="text"
          label=""
          placeholder="Enter Website URL"
          inputClass="placeholder:!text-[#767676]"
          width="100%"
          radius="5px"
          InputDivClass="w-full mt-4"
          name="websiteUrl"
          data-field="websiteUrl"
          value={websiteUrl}
          handleChange={handleChange}
          handleBlur={handleBlur}
          error={errors.websiteUrl}
          touched={touched.websiteUrl}
        />
        <style>{`
          /* Standardize error text sizes for all inputs in getStarted form */
          .getStarted .text-red-600 {
            font-size: 10px !important;
          }
          @media (min-width: 640px) {
            .getStarted .text-red-600 {
              font-size: 10px !important;
            }
          }
          @media (min-width: 768px) {
            .getStarted .text-red-600 {
              font-size: 12px !important;
            }
          }
          /* Force placeholder color for Phone Input to match others (#767676) */
          .getStarted .react-tel-input input::placeholder {
            color: #767676 !important;
            opacity: 1 !important;
          }
        `}</style>
        <Input
          type="text"
          label=""
          placeholder="Contact Person Name"
          inputClass="placeholder:!text-[#767676]"
          width="100%"
          radius="5px"
          InputDivClass="w-full mt-4"
          name="personName"
          data-field="personName"
          value={personName}
          handleChange={handleChange}
          handleBlur={handleBlur}
          error={errors.personName}
          touched={touched.personName}
        />

        <Input
          type="text"
          label=""
          placeholder="Business Email Address"
          inputClass="placeholder:!text-[#767676]"
          width="100%"
          radius="5px"
          InputDivClass="w-full mt-4"
          name="email"
          data-field="email"
          value={email}
          handleChange={(e) => {
            handleChange(e);
            // Clear error when user types
            if (emailExistsAsUser) {
              setEmailExistsAsUser(false);
            }
          }}
          handleBlur={async (e) => {
            handleBlur(e);
            // Check if email is registered as User/Member on blur (only if not from authenticated merchant)
            if (email && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) && (!merchantEmail || email !== merchantEmail)) {
              await checkEmailExistsAsUser(email);
            }
          }}
          error={emailExistsAsUser ? "This email is already registered. Please use a different email address or sign in with your existing account." : errors.email}
          touched={touched.email || emailExistsAsUser}
          disabled={isInvitedMerchant || merchantEmail ? true : false}
        />
        {isCheckingEmail && !merchantEmail && (
          <p className="text-[10px] sm:text-[12px] text-[#767676] mt-1 w-full text-left">
            Checking email...
          </p>
        )}

        {/* <div className="flex mt-6 sm:mt-7 items-center gap-4 sm:gap-8 justify-start w-full" data-field="logo"> */}
        <div className="flex mt-6 sm:mt-7 items-center gap-2 sm:gap-4 justify-start w-full">

          <div
            className="relative h-[80px] w-[80px] rounded-[10px] border-2 border-solid border-[#E4E3E4] flex justify-center items-center logo cursor-pointer bg-white overflow-hidden"
            onClick={() => document.getElementById("fileInput")?.click()}
          >
            {logoLoading == true && <Loader />}
            {logoFileImage !== undefined ? (
              <img
                src={logoFileImage}
                className="select-none"
                style={{
                  imageRendering: "auto",
                  borderRadius: "10px",
                  display: "block",
                  ...logoPreviewStyle,
                }}
                onLoad={(event) => {
                  try {
                    const { naturalWidth, naturalHeight } = event.target || {};
                    if (!naturalWidth || !naturalHeight) {
                      setLogoPreviewStyle({});
                      return;
                    }
                    const widthRatio = naturalWidth / naturalHeight;
                    const heightRatio = naturalHeight / naturalWidth;
                    const widthMultiplier = 1.15;
                    const heightMultiplier = 1.08;
                    setLogoPreviewStyle({
                      width: widthRatio >= 1 ? `${(widthRatio || 1) * 100 * widthMultiplier}%` : `${100 * widthMultiplier}%`,
                      height: heightRatio >= 1 ? `${(heightRatio || 1) * 100 * heightMultiplier}%` : `${100 * heightMultiplier}%`,
                    });
                  } catch (error) {
                    setLogoPreviewStyle({});
                  }
                }}
                alt="Business Logo Preview"
              />
            ) : (
              <CameraIcon />
            )}
          </div>
          <input
            type="file"
            id="fileInput"
            hidden
            accept=".jpg,.jpeg,.png,.svg"
            onChange={handleUploadLogo}
          />
          {logoFileImage !== undefined ? (
            <p
              className="font-poppins font-[400] text-[12px] md:text-[14px] text-[#535353] cursor-pointer transition-colors hover:text-red-500"
              onClick={handleClearLogo}
            >
              Clear
            </p>
          ) : (
            <div className="flex flex-col justify-start">
              <p className="font-poppins font-[400] text-[12px] md:text-[14px] text-[#535353]">
                Upload Logo <span className="text-[10px] md:text-[12px]">(Optional)</span>
              </p>
              <p className="font-poppins font-[400] text-[10px] md:text-[12px] text-[#00adef]">
                File type: must be an svg, jpeg, jpg, or png <br />
                Max Image Size: 1MB
              </p>

            </div>
          )}
        </div>


        <InputTextArea
          // label={"Tell more about your business"}
          placeholder={
            "Business Description"
          }
          divClassName="relative mt-4 w-full"
          labelClassName="invitationLabels !mb-2"
          textareaClassName="w-full h-[150px] px-3 pt-2 rounded-[5px] bg-[#FFFFFF] border border-[#D9D9D9] text-[#303030] lg:text-[14px] sm:text-[14px] font-[400] outline-none resize-none font-poppins placeholder:text-[14px] sm:placeholder:text-[14px] lg:placeholder:text-[14px] placeholder:!text-[#767676]"
          name="aboutBusiness"
          data-field="aboutBusiness"
          value={aboutBusiness}
          handleBlur={handleBlur}
          error={errors.aboutBusiness}
          touched={touched.aboutBusiness}
          setFieldValue={setFieldValue}
        />
        {/* <Input
          type="text"
          label={
            referralCode == ""
              ? "Provide Fundraiser Referral Code if you have any"
              : ""
          }
          placeholder="Fundraiser Referral Code"
          width="100%"
          radius="5px"
          InputDivClass="w-full mt-4"
          inputClass={
            referralCode == undefined ? "" : "cursor-not-allowed opacity-70"
          }
          name="code"
          value={code}
          handleChange={handleChange}
          handleBlur={handleBlur}
          error={errors.code}
          touched={touched.code}
          disabled={referralCode != undefined}
        /> */}
        {/* <p className="text-[10px] sm:text-[12px] md:text-[14px] font-poppins font-[400] mt-8 text-center w-[90%]">
          By clicking sign up, I agree to the
          <span
            className="text-[#00ADEF] font-[500] cursor-pointer"
            onClick={() => window.open("/privacy/toc", "_blank")}
          >
            {" "}
            Terms of Use{" "}
          </span>
          that I have read the
          <span
            className="text-[#00ADEF] font-[500] cursor-pointer"
            onClick={() => window.open("/privacy/policy", "_blank")}
          >
            {" "}
            Privacy Policy.
          </span>
        </p> */}
        <div className="flex flex-col items-center w-[92%] sm:w-[90%] mt-8 text-center px-1">
          <p className="text-[10px] sm:text-[12px] md:text-[14px] font-poppins font-[400]">
            By clicking  <span
              className="text-[#00ADEF] font-[500] cursor-pointer"
              onClick={() => window.open("/merchant/getting-started", "_blank")}
            >
              {" "}
              Sign Up{" "}
            </span>, I agree to our
            <span
              className="text-[#00ADEF] font-[500] cursor-pointer"
              onClick={() => window.open("/privacy/toc", "_blank")}
            >
              {" "}
              Terms of Use{" "}
            </span>
            and <br />acknowledge the
            <span
              className="text-[#00ADEF] font-[500] cursor-pointer"
              onClick={() => window.open("/privacy/policy", "_blank")}
            >
              {" "}
              Privacy Policy.
            </span>
          </p>

          <div className="flex items-center gap-1 mt-4">
            <p className="sm:text-[12px] md:text-[14px] font-poppins font-[400]">
              Already have an account?
            </p>
            <span
              className="text-[#00ADEF] font-[500] sm:text-[12px] md:text-[14px] cursor-pointer"
              onClick={() => navigate("/")}
            >
              Sign In
            </span>
          </div>
        </div>

        <PrimaryButton
          type={"submit"}
          className={
            "w-[80%] sm:w-[60%] md:w-[60%] lg:w-[70%] font-poppins text-[16px] sm:text-[16px] md:text-[18px] lg:text-[20px] text-center font-[500] h-[46px] sm:h-[50px] md:h-[55px] lg:h-[60px] rounded-[10px] my-8 sm:my-10"
          }
          label="SIGN UP"
        />
      </div>
    </form >
  );
};

export default GettingStarted;